// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';

// 导入你的页面组件
import HomePage from '@/views/HomePage.vue'; 
import productsPage from '@/views/productsPage.vue'; 
import accessories from '@/views/accessories.vue'; 
import aiServices from '@/views/aiServices.vue'; 
import applications from '@/views/applications.vue'; 
import art from '@/views/art.vue'; 
import resources from '@/views/resources.vue';  
import webinars from '@/views/webinars.vue';  
import careers from '@/views/careers.vue';  
import company from '@/views/company.vue'; 
import news from '@/views/news.vue';
import events from '@/views/events.vue';
import partners from '@/views/partners.vue';
import contact from '@/views/contact.vue';
import documents from '@/views/documents.vue';
import diana from '@/views/diana.vue';
import frankaResearch3 from '@/views/frankaResearch3.vue';
import mobileFr3Duo from '@/views/mobileFr3Duo.vue';

import newsDetails from '@/views/newsDetails.vue';
import matlab from '@/views/matlab.vue';
// import dataPlatform from '@/views/dataPlatform.vue';
import develop from '@/views/develop.vue';
import companion from '@/views/companion.vue';
import releases from '@/views/releases.vue';
import community from '@/views/community.vue';
import fr3Duo from '@/views/prototypes/fr3_duo.vue';
import mobile_fr3_duo from '@/views/prototypes/mobile_fr3_duo.vue';
import tmr from '@/views/prototypes/tmr.vue';
import gello from '@/views/prototypes/gello.vue';
import frankaHand from '@/views/products/franka_hand.vue';
import cobotPump from '@/views/products/cobot_pump.vue';
import labs from '@/views/labs.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: "Franka Robotics - 领先的协作机器人技术",
      metaTags: [
        {
          name: 'description',
          content: 'Franka Robotics提供创新的协作机器人解决方案，包括Franka Research 3和Diana 7等产品，适用于工业自动化和科研领域。协作机器人,工业自动化,Franka Robotics,机器人技术,智能制造'
        }
      ]
    },
    beforeEnter: () => console.log('Navigating to Home'),  // 调试日志
  },
  {
    path: '/products',
    name: 'products',
    component: productsPage, 
    meta: {
      title: "Franka Robotics",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka Research 3,Diana 7,Franka Hand,FCI控制接口,Franka ROS 2,MATLAB机器人工具箱'
        }
      ]
    }
  },
  {
    path: '/ai-services',
    name: 'aiServices',
    component: aiServices, 
    meta: {
      title: "Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka AI Companion,AI服务,机器人智能,自动控制,智能助手'
        }
      ]
    }
  },
  {
    path: '/accessories',
    name: 'accessories',
    component: accessories, 
    meta: {
      title: "Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka Hand,COBOT PUMP,Schmalz,Zimmer,MATCH,ROBOCEPTION,Murrplastik,Franka AI Companion '
        }
      ]
    }
  },
  {
    path: '/applications',
    name: 'applications',
    component: applications, 
    meta: {
      title: "Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka机器人应用,工业自动化,医疗机器人,服务机器人,教育机器人,农业自动化'
        }
      ]
    }
  },
  {
    path: '/art',
    name: 'art',
    component: art, 
    meta: {
      title: "Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka艺术,艺术机器人,机器人艺术'
        }
      ]
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component: resources, 
    meta: {
      title: "Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,Franka Research 3,Franka社区论坛,机器人平台,Franka机械臂'
        }
      ]
    }
  },
  {
    path: '/webinars',
    name: 'webinars',
    component: webinars, 
    meta: {
      title: "Franka Robotics Webinars,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,机器人网络研讨会,技术培训,工业自动化讲座,机器人开发教程'
        }
      ]
    }
  },
  {
    path: '/careers',
    name: 'careers',
    component: careers, 
    meta: {
      title: "Franka Robotics Careers,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics,机器人工程师职位,技术岗位招聘,机器人研发工作,慕尼黑工作机会'
        }
      ]
    }
  },
  {
    path: '/company',
    name: 'company',
    component: company, 
    meta: {
      title: "About Franka Robotics,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics公司,机器人技术创新,德国机器人企业,工业自动化解决方案,科研合作伙伴'
        }
      ]
    }
  },
  {
    path: '/news',
    name: 'news',
    component: news, 
    meta: {
      title: "Franka Robotics 新闻,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics新闻,机器人行业动态,技术创新公告,产品发布,科研合作消息'
        }
      ]
    }
  },
  {
    path: '/events',
    name: 'events',
    component: events, 
    meta: {
      title: "Franka Robotics Events,Franka 中国",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics活动,机器人展会,技术研讨会,行业会议,慕尼黑机器人活动'
        }
      ]
    }
  },
  {
    path: '/partners',
    name: 'partners',
    component: partners, 
    meta: {
      title: "Franka Robotics Partners",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics合作伙伴,工业自动化联盟,技术集成商,科研机构合作,西门子合作伙伴'
        }
      ]
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact, 
    meta: {
      title: "Contact Franka Robotics",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics联系方式,技术支持,销售咨询,客户服务,德国总部地址'
        }
      ]
    }
  },
  {
    path: '/documents',
    name: 'documents',
    component: documents, 
    meta: {
      title: "Franka Robotics Documents",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka Robotics文档,产品手册,技术规格书,安装指南,用户手册,API文档,开发指南,证书文件,安全认证'
        }
      ]
    }
  },
  {
    path: '/products/diana-7',
    name: 'diana',
    component: diana, 
    meta: {
      title: "Diana 7协作机器人 - Franka Robotics",
      metaTags: [
        {
          name: 'keywords',
          content: 'Diana 7机器人,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/products/franka-research-3',
    name: 'frankaResearch3',
    component: frankaResearch3, 
    meta: {
      title: "FRANKA RESEARCH 3",
      metaTags: [
        {
          name: 'keywords',
          content: 'FRANKA RESEARCH 3,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/product-prototypes',
    name: 'mobileFr3Duo',
    component: mobileFr3Duo, 
    meta: {
      title: "Mobile FR3 Duo",
      metaTags: [
        {
          name: 'keywords',
          content: 'Mobile FR3 Duo,移动型FR3,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/products/franka-research-3/releases',
    name: 'releases',
    component: releases, 
    meta: {
      title: "FRANKA RESEARCH 3 releases",
      metaTags: [
        {
          name: 'keywords',
          content: 'FRANKA RESEARCH 3,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/products/franka-ai-companion',
    name: 'ai-companion',
    component: companion, 
    meta: {
      title: "FRANKA AI companion",
      metaTags: [
        {
          name: 'keywords',
          content: 'AI伴侣机器人,智能协作系统,工业AI解决方案,自动化生产助手,机器学习集成'
        }
      ]
    }
  },
  {
    path: '/newsDetails/:id', 
    name: 'newsDetails',
    component: newsDetails, 
  },
  {
    path: '/matlab', 
    name: 'matlab',
    component: matlab, 
    meta: {
      title: "Franka Robotics MATLAB Integration",
      metaTags: [
        {
          name: 'keywords',
          content: 'MATLAB机器人控制,Simulink集成,机器人仿真,算法开发,科研工具包'
        }
      ]
    }
  },
  // {
  //   path: '/dataPlatform', 
  //   name: 'dataPlatform',
  //   component: dataPlatform, 
  // },
  {
    path: '/develop', 
    name: 'develop',
    component: develop, 
    meta: {
      title: "Franka Robotics Development Center",
      metaTags: [
        {
          name: 'keywords',
          content: '机器人开发平台,SDK下载,API文档,示例代码,ROS 2集成,实时控制接口'
        }
      ]
    }
  },
  {
    path: '/community', 
    name: 'community',
    component: community, 
    meta: {
      title: "Franka 社区",
      metaTags: [
        {
          name: 'keywords',
          content: 'Franka 社区，社区贡献'
        }
      ]
    }
  },
  {
    path: '/fr3-duo',
    name: 'fr3Duo',
    component: fr3Duo, 
    meta: {
      title: "FRa Research 3 双机版",
      metaTags: [
        {
          name: 'keywords',
          content: 'FRa Research 3 双机版,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/mobile-fr3-duo',
    name: 'mobile_fr3_duo',
    component: mobile_fr3_duo, 
    meta: {
      title: "Mobile FR3 Duo",
      metaTags: [
        {
          name: 'keywords',
          content: 'Mobile FR3 Duo,移动型FR3,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/tmr',
    name: 'tmr',
    component: tmr, 
    meta: {
      title: "TM-Robotics",
      metaTags: [
        {
          name: 'keywords',
          content: 'TM-Robotics,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/gello',
    name: 'gello',
    component: gello, 
    meta: {
      title: "Gello",
      metaTags: [
        {
          name: 'keywords',
          content: 'Gello,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/franka-hand',
    name: 'frankaHand',
    component: frankaHand, 
    meta: {
      title: "FRANKA Hand",
      metaTags: [
        {
          name: 'keywords',
          content: 'FRANKA Hand,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/cobot-pump',
    name: 'cobotPump',
    component: cobotPump, 
    meta: {
      title: "COBOT Pump",
      metaTags: [
        {
          name: 'keywords',
          content: 'COBOT Pump,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
  {
    path: '/labs',
    name: 'labs',
    component: labs,
    meta: {
      title: "LABS",
      metaTags: [
        {
          name: 'keywords',
          content: 'LABS,7自由度机械臂,协作机器人,工业自动化,力反馈控制,科研机器人平台'
        }
      ]
    }
  },
];  
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    // 如果是带有锚点的跳转
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        return { el: to.hash, behavior: 'smooth' }; // 平滑滚动到目标元素
      }
    }
    return { top: 0 }; // 默认返回到页面顶部
  },
});

export default router;
